<template>
  <h1>holi {{message}} </h1>
  <div>{{count}}</div>
  <div>{{ $page.props.user }}</div>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    props: ['message'],
    setup(props) {
        const store = useStore();
        console.log(props) // { user: '' }

        return {
            count: computed(() => store.state.count)
        } // anything returned here will be available for the rest of the component
    }
}
</script>

<style>

</style>